<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">
            <app-filtros-reportes #ctrl [datos]="datos" [cargando]="cargando" ruta="resumen/proveedor"></app-filtros-reportes>

            <div style="overflow:auto; height: 85.8vh;">
                <div id="imprimir">
                    <!--Tabla -->
                    <table id class="table is-striped  is-fullwidth" *ngIf="!cargando ">
                        <thead>
                            <tr>
                                <th>Proveedor</th>
                                <th>Articulos</th>
                                <th>Total Art.</th>
                                <th>Subtotal</th>
                                <th>Descuento</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of ctrl.datos; let i=index">
                                <td>{{ item.cliente?.nombre }}</td>
                                <td>{{ item.total_articulos}}</td>
                                <td>{{ item.total_contador}}</td>
                                <td>{{ item.subtotal | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</td>
                                <td>{{ item.descuento | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}} </td>
                                <td>{{ item.total | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</td>
                            </tr>
                            <tr *ngIf="ctrl.datos.length == 0">
                                <td colspan="5" style="vertical-align: middle; color:#888;">Esta lista está vacía.</td>
                            </tr>
                        </tbody>

                        <tfoot>
                            <tr>
                                <th colspan="3" align="right">
                                    <div align="right">Subtotal</div>
                                </th>
                                <th colspan="3">
                                    <div align="left">{{ctrl.subtotal | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</div>
                                </th>
                            </tr>
                            <tr>
                                <th colspan="3" align="right">
                                    <div align="right">Descuento</div>
                                </th>
                                <th></th>
                                <th colspan="2">
                                    <div align="left">{{ctrl.descuento | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</div>
                                </th>
                            </tr>
                            <tr>
                                <th colspan="3" align="right">
                                    <div align="right">Total</div>
                                </th>
                                <th></th>
                                <th></th>
                                <th>
                                    <div align="left">{{ctrl.gran_total | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</div>
                                </th>
                            </tr>
                        </tfoot>

                    </table>
                </div>
            </div>
        </div>
    </div>
</div>